(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["client-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('labelmentor-testimonials')) {
  customElements.define('labelmentor-testimonials', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const rail = this.querySelector('.lm-testimonials__rail');
      const previous = this.querySelector('[data-lm-previous]');
      const next = this.querySelector('[data-lm-next]');
      const options = { signal: this.controller.signal };
      const sync = () => {
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };
      const move = (direction) => {
        const card = rail.querySelector('.lm-testimonials__card');
        const gap = parseFloat(getComputedStyle(rail).gap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : rail.clientWidth;
        rail.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      rail.addEventListener('scroll', sync, { ...options, passive: true });
      this.observer = new ResizeObserver(sync);
      this.observer.observe(rail);
      sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discovery-booking"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots=document.querySelectorAll('[data-booking-root]');
  roots.forEach(function(root){
    if(root.dataset.bookingReady==='true') return;
    root.dataset.bookingReady='true';

    var grid=root.querySelector('[data-calendar-grid]');
    var monthLabel=root.querySelector('[data-calendar-month]');
    var prev=root.querySelector('[data-calendar-prev]');
    var next=root.querySelector('[data-calendar-next]');
    var dateSummary=root.querySelector('[data-selected-date-summary] span:last-child');
    var timesDate=root.querySelector('[data-times-date]');
    var timeButtons=[].slice.call(root.querySelectorAll('[data-time-slot]'));
    var timeList=root.querySelector('[data-time-list]');
    var formWrap=root.querySelector('[data-booking-form]');
    var back=root.querySelector('[data-booking-back]');
    var dateInput=root.querySelector('[data-booking-date-input]');
    var timeInput=root.querySelector('[data-booking-time-input]');
    var timezoneInput=root.querySelector('[data-booking-timezone-input]');
    var timezoneLabel=root.querySelector('[data-timezone-label]');
    var bookingSummary=root.querySelector('[data-booking-summary]');
    var weekdayLabels=[].slice.call(root.querySelectorAll('.lm-booking__weekdays span'));

    var minNotice=parseInt(root.getAttribute('data-min-notice')||'1',10);
    var bookingWindow=parseInt(root.getAttribute('data-booking-window')||'60',10);
    var today=new Date(); today.setHours(0,0,0,0);
    var firstBookable=new Date(today); firstBookable.setDate(firstBookable.getDate()+Math.max(0,minNotice));
    var lastBookable=new Date(today); lastBookable.setDate(lastBookable.getDate()+Math.max(7,bookingWindow));
    var selectedDate=null;
    var selectedTime='';
    var view=new Date(firstBookable.getFullYear(),firstBookable.getMonth(),1);
    var tz='Local time';
    try{ tz=Intl.DateTimeFormat().resolvedOptions().timeZone || tz; }catch(e){}
    if(timezoneLabel) timezoneLabel.textContent=tz;
    if(timezoneInput) timezoneInput.value=tz;

    function localeForLanguage(){
      var lang=(document.documentElement.lang||'en').toLowerCase();
      return {de:'de-DE',fr:'fr-FR',es:'es-ES',ro:'ro-RO'}[lang] || 'en-GB';
    }
    function pad(n){ return String(n).padStart(2,'0'); }
    function isoDate(d){ return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate()); }
    function humanDate(d){
      return d.toLocaleDateString(localeForLanguage(),{weekday:'short',day:'numeric',month:'short',year:'numeric'});
    }
    function renderWeekdays(){
      if(!weekdayLabels.length) return;
      var monday=new Date(2024,0,1); // Monday
      weekdayLabels.forEach(function(label,index){
        var d=new Date(monday); d.setDate(monday.getDate()+index);
        label.textContent=d.toLocaleDateString(localeForLanguage(),{weekday:'short'}).replace(/\.$/,'');
      });
    }
    function sameDate(a,b){ return a&&b&&a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate(); }
    function isBookable(d){
      var day=d.getDay();
      return d>=firstBookable && d<=lastBookable && day!==0 && day!==6;
    }
    function nextBookable(d){
      var x=new Date(d);
      while(x<=lastBookable && !isBookable(x)) x.setDate(x.getDate()+1);
      return x<=lastBookable?x:null;
    }
    function updateNav(){
      var firstMonth=new Date(firstBookable.getFullYear(),firstBookable.getMonth(),1);
      var lastMonth=new Date(lastBookable.getFullYear(),lastBookable.getMonth(),1);
      if(prev) prev.disabled=view<=firstMonth;
      if(next) next.disabled=view>=lastMonth;
    }
    function selectDate(d){
      selectedDate=new Date(d.getFullYear(),d.getMonth(),d.getDate());
      selectedTime='';
      if(dateInput) dateInput.value=isoDate(selectedDate);
      if(timeInput) timeInput.value='';
      if(dateSummary) dateSummary.textContent=humanDate(selectedDate);
      if(timesDate) timesDate.textContent=humanDate(selectedDate);
      timeButtons.forEach(function(btn){ btn.classList.remove('is-selected'); btn.disabled=false; });
      if(formWrap) formWrap.hidden=true;
      if(timeList) timeList.hidden=false;
      renderCalendar();
    }
    function renderCalendar(){
      if(!grid) return;
      grid.innerHTML='';
      if(monthLabel) monthLabel.textContent=view.toLocaleDateString(localeForLanguage(),{month:'long',year:'numeric'});
      renderWeekdays();
      var first=new Date(view.getFullYear(),view.getMonth(),1);
      var offset=(first.getDay()+6)%7;
      var days=new Date(view.getFullYear(),view.getMonth()+1,0).getDate();
      for(var i=0;i<offset;i++){
        var blank=document.createElement('span'); blank.className='lm-booking__day lm-booking__day--blank'; blank.setAttribute('aria-hidden','true'); grid.appendChild(blank);
      }
      for(var day=1;day<=days;day++){
        (function(dayNum){
          var d=new Date(view.getFullYear(),view.getMonth(),dayNum);
          var btn=document.createElement('button');
          btn.type='button';
          btn.className='lm-booking__day';
          btn.textContent=String(dayNum);
          btn.setAttribute('aria-label',humanDate(d));
          btn.setAttribute('role','gridcell');
          if(sameDate(d,today)) btn.classList.add('is-today');
          if(sameDate(d,selectedDate)){ btn.classList.add('is-selected'); btn.setAttribute('aria-pressed','true'); }
          if(!isBookable(d)){ btn.disabled=true; btn.classList.add('is-disabled'); }
          else btn.addEventListener('click',function(){ selectDate(d); });
          grid.appendChild(btn);
        })(day);
      }
      updateNav();
    }

    if(prev) prev.addEventListener('click',function(){ view=new Date(view.getFullYear(),view.getMonth()-1,1); renderCalendar(); });
    if(next) next.addEventListener('click',function(){ view=new Date(view.getFullYear(),view.getMonth()+1,1); renderCalendar(); });

    timeButtons.forEach(function(btn){
      btn.addEventListener('click',function(){
        if(!selectedDate) return;
        selectedTime=btn.getAttribute('data-time-slot')||'';
        timeButtons.forEach(function(b){ b.classList.toggle('is-selected',b===btn); });
        if(timeInput) timeInput.value=selectedTime;
        if(bookingSummary) bookingSummary.textContent=humanDate(selectedDate)+' · '+selectedTime+' · '+tz;
        if(timeList) timeList.hidden=true;
        if(formWrap){ formWrap.hidden=false; formWrap.scrollIntoView({behavior:'smooth',block:'start'}); }
      });
    });

    if(back) back.addEventListener('click',function(){
      if(formWrap) formWrap.hidden=true;
      if(timeList) timeList.hidden=false;
    });

    var initial=nextBookable(firstBookable);
    if(initial){ view=new Date(initial.getFullYear(),initial.getMonth(),1); selectDate(initial); }
    else renderCalendar();

    if(root.querySelector('.lm-booking__success')){
      if(timeList) timeList.hidden=true;
      if(formWrap) formWrap.hidden=false;
    }

    document.addEventListener('labelmentor:languagechange',function(){
      setTimeout(function(){
        renderCalendar();
        if(selectedDate){
          if(dateSummary) dateSummary.textContent=humanDate(selectedDate);
          if(timesDate) timesDate.textContent=humanDate(selectedDate);
          if(bookingSummary && selectedTime) bookingSummary.textContent=humanDate(selectedDate)+' · '+selectedTime+' · '+tz;
        }
      },0);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
